// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2j3ir","legacyBtn":"MutateMid_legacyBtn__3bYLW"};